export default __webpack_public_path__ + "static/media/sam.5e0f1a11.png";